import React, { useState, useRef, useEffect } from 'react';
import './ShareButtons.css';

// Botões de compartilhamento reutilizáveis. Recebe a URL absoluta da página e o
// título; a foto que aparece no preview vem das meta tags Open Graph servidas
// por backend/utils/socialMeta.js — nenhuma rede aceita a imagem pelo link.
//
// Qualquer página nova (inclusive as criadas pela área administrativa) ganha o
// mesmo recurso importando este componente e passando url e title.

const WhatsAppIcon = () => (
  <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
  </svg>
);

const LinkIcon = () => (
  <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
  </svg>
);

const copiarParaAreaDeTransferencia = async (texto) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
  } catch {
    /* cai no método antigo abaixo */
  }

  // Fallback para navegadores sem clipboard API ou fora de contexto seguro (http).
  try {
    const campo = document.createElement('textarea');
    campo.value = texto;
    campo.setAttribute('readonly', '');
    campo.style.position = 'fixed';
    campo.style.opacity = '0';
    document.body.appendChild(campo);
    campo.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(campo);
    return ok;
  } catch {
    return false;
  }
};

export default function ShareButtons({ url, title, className = '' }) {
  const [aviso, setAviso] = useState('');
  const timeoutRef = useRef(null);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const mostrarAviso = (texto) => {
    setAviso(texto);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setAviso(''), 3200);
  };

  if (!url) return null;

  const textoCompartilhado = title ? `${title} — ${url}` : url;

  const abrir = (endereco) => {
    window.open(endereco, '_blank', 'noopener,noreferrer');
  };

  const compartilharWhatsApp = () => {
    abrir(`https://wa.me/?text=${encodeURIComponent(textoCompartilhado)}`);
  };

  const compartilharFacebook = () => {
    abrir(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`);
  };

  // O Instagram não tem endereço de compartilhamento na web: não existe forma de
  // abrir o app já com um link preenchido. O caminho possível é o menu nativo do
  // celular (onde o Instagram aparece como destino) e, sem ele, copiar o link.
  const compartilharInstagram = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text: title, url });
        return;
      } catch (err) {
        if (err?.name === 'AbortError') return; // usuário fechou o menu
      }
    }

    const copiou = await copiarParaAreaDeTransferencia(url);
    mostrarAviso(copiou
      ? 'Link copiado! Cole no seu story ou na bio do Instagram.'
      : 'Não foi possível copiar. Copie o link da barra de endereços.');
  };

  const copiarLink = async () => {
    const copiou = await copiarParaAreaDeTransferencia(url);
    mostrarAviso(copiou ? 'Link copiado!' : 'Não foi possível copiar o link.');
  };

  return (
    <div className={`share-buttons ${className}`.trim()}>
      <span className="share-label">Compartilhar:</span>

      <div className="share-actions">
        <button type="button" onClick={compartilharWhatsApp}
          className="share-btn share-whatsapp" title="Compartilhar no WhatsApp"
          aria-label="Compartilhar no WhatsApp">
          <WhatsAppIcon />
          <span>WhatsApp</span>
        </button>

        <button type="button" onClick={compartilharFacebook}
          className="share-btn share-facebook" title="Compartilhar no Facebook"
          aria-label="Compartilhar no Facebook">
          <FacebookIcon />
          <span>Facebook</span>
        </button>

        <button type="button" onClick={compartilharInstagram}
          className="share-btn share-instagram" title="Compartilhar no Instagram"
          aria-label="Compartilhar no Instagram">
          <InstagramIcon />
          <span>Instagram</span>
        </button>

        <button type="button" onClick={copiarLink}
          className="share-btn share-copy" title="Copiar link"
          aria-label="Copiar link do produto">
          {aviso === 'Link copiado!' ? <CheckIcon /> : <LinkIcon />}
          <span>Copiar link</span>
        </button>
      </div>

      <span className="share-feedback" role="status" aria-live="polite">{aviso}</span>
    </div>
  );
}
